"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRouterDom = require("react-router-dom");

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Taken from
 * https://github.com/ReactTraining/react-router
 *  /blob/10069457db64f60a68577fd55966375af2ae5f8e/packages/react-router/modules/Switch.js
 */
var Switch =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, (Switch.__proto__ || Object.getPrototypeOf(Switch)).apply(this, arguments));
  }

  _createClass(Switch, [{
    key: "render",
    value: function render() {
      var route = this.context.router.route;
      var _props = this.props,
          children = _props.children,
          onNoMatch = _props.onNoMatch;
      var location = this.props.location || route.location;
      var match, child;

      _react.default.Children.forEach(children, function (element) {
        if (match == null && _react.default.isValidElement(element)) {
          var _element$props = element.props,
              pathProp = _element$props.path,
              basePath = _element$props.basePath,
              exact = _element$props.exact,
              strict = _element$props.strict,
              sensitive = _element$props.sensitive,
              from = _element$props.from;
          var path = (0, _utils.buildUrl)(basePath, pathProp || from);
          child = element;
          match = path ? (0, _reactRouterDom.matchPath)(location.pathname, {
            path: path,
            exact: exact,
            strict: strict,
            sensitive: sensitive
          }) : route.match;
        }
      });

      if (match) {
        return _react.default.cloneElement(child, {
          location: location,
          computedMatch: match
        });
      } else {
        onNoMatch ? onNoMatch() : null;
        return null;
      }
    }
  }]);

  return Switch;
}(_react.default.Component);

Object.defineProperty(Switch, "contextTypes", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    router: _propTypes.default.shape({
      route: _propTypes.default.object.isRequired
    }).isRequired
  }
});
Object.defineProperty(Switch, "propTypes", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    children: _propTypes.default.node,
    location: _propTypes.default.object
  }
});
var _default = Switch;
exports.default = _default;